
let SERVER_ROOT;
let CLIENT_ROOT;
let extensionId;
let PADDLE_ENV;
let PADDLE_CLIENT_TOKEN;
let PADDLE_PRICE_ID_MONTHLY;
let PADDLE_PRICE_ID_YEARLY;
let PADDLE_PRICE_ID_PRO_MONTHLY;
let PADDLE_PRICE_ID_PRO_YEARLY;
let PADDLE_PRICE_ID_ULTRA_MONTHLY;
let PADDLE_PRICE_ID_ULTRA_YEARLY;

//extensionId = 'malnhaodjdegcljjebmpopbjmckblndn';

if (process.env.NODE_ENV === 'development') {
  SERVER_ROOT = 'http://localhost:8080';
  CLIENT_ROOT = 'http://localhost:3030';
  extensionId = 'mdiamglopikhbbahjomkafkceggdoing';
  PADDLE_ENV = process.env.REACT_APP_PADDLE_ENV || 'sandbox';
  PADDLE_CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN || '';
  PADDLE_PRICE_ID_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_MONTHLY || '';
  PADDLE_PRICE_ID_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_YEARLY || '';
  PADDLE_PRICE_ID_PRO_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_PRO_MONTHLY || '';
  PADDLE_PRICE_ID_PRO_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_PRO_YEARLY || '';
  PADDLE_PRICE_ID_ULTRA_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_ULTRA_MONTHLY || '';
  PADDLE_PRICE_ID_ULTRA_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_ULTRA_YEARLY || '';
} else {
  SERVER_ROOT = 'https://api.hashely.me';
  CLIENT_ROOT = 'https://hashely.me';
  extensionId = 'malnhaodjdegcljjebmpopbjmckblndn';
  PADDLE_ENV = process.env.REACT_APP_PADDLE_ENV || 'production';
  PADDLE_CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN || '';
  PADDLE_PRICE_ID_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_MONTHLY || '';
  PADDLE_PRICE_ID_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_YEARLY || '';
  PADDLE_PRICE_ID_PRO_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_PRO_MONTHLY || '';
  PADDLE_PRICE_ID_PRO_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_PRO_YEARLY || '';
  PADDLE_PRICE_ID_ULTRA_MONTHLY = process.env.REACT_APP_PADDLE_PRICE_ID_ULTRA_MONTHLY || '';
  PADDLE_PRICE_ID_ULTRA_YEARLY = process.env.REACT_APP_PADDLE_PRICE_ID_ULTRA_YEARLY || '';
}

const googleAdIds = [
  '8301814549',
  '4277442070',
  '2879765779',
  '8650171047',
  '7808696819',
]
    

const EXTENSION_URL = 'https://chrome.google.com/webstore/detail/trends/malnhaodjdegcljjebmpopbjmckblndn';

module.exports = {
  SERVER_ROOT,
  CLIENT_ROOT,
  extensionId,
  googleAdIds,
  EXTENSION_URL,
  PADDLE_ENV,
  PADDLE_CLIENT_TOKEN,
  PADDLE_PRICE_ID_MONTHLY,
  PADDLE_PRICE_ID_YEARLY,
  PADDLE_PRICE_ID_PRO_MONTHLY,
  PADDLE_PRICE_ID_PRO_YEARLY,
  PADDLE_PRICE_ID_ULTRA_MONTHLY,
  PADDLE_PRICE_ID_ULTRA_YEARLY,
};
